import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import Input from './TimeInput';

type SettingRowProps = {
 label?: string;
 hours?: string;
 minutes: string;
 seconds: string;
}

const SettingRow: FC<SettingRowProps> = ({label, hours, minutes, seconds}) => {
  const {t} = useTranslation('targetTaskTime');

  return (
    <div className="setting">
      <label className="label">{label}</label>
      <div className="time-inputs">
        {hours && <Input value={hours} description={t('hours')} />}
        <Input value={minutes} description={t('minutes')} />
        <Input value={seconds} description={t('seconds')} />
      </div>
    </div>
  );
};

export default SettingRow;
